<template>
  <div class="cultura-container">
    <div class="cultura-title">Una cultura en la que prosperarás</div>

    <div class="cards-container">
      <div class="cultura-card">
        <div class="card-image-container">
          <img
            :src="require('../../assets/newlanding/Landing/diversidad.png')"
            alt="Diversidad e igualdad"
            class="card-image"
          />
          <div class="card-overlay"></div>
          <h3 class="card-title">Diversidad e igualdad</h3>
        </div>
      </div>

      <div class="cultura-card">
        <div class="card-image-container">
          <img
            :src="require('../../assets/newlanding/Landing/crecemos.png')"
            alt="Creemos en las personas"
            class="card-image"
          />
          <div class="card-overlay"></div>
          <h3 class="card-title">Creemos en las personas</h3>
        </div>
      </div>

      <div class="cultura-card">
        <div class="card-image-container">
          <img
            :src="require('../../assets/newlanding/Landing/mentalidad.png')"
            alt="Mentalidad digital"
            class="card-image"
          />
          <div class="card-overlay"></div>
          <h3 class="card-title">Mentalidad digital</h3>
        </div>
      </div>

      <div class="cultura-card">
        <div class="card-image-container">
          <img
            :src="require('../../assets/newlanding/Landing/equipo.png')"
            alt="Equipo unido y colaborativo"
            class="card-image"
          />
          <div class="card-overlay"></div>
          <h3 class="card-title">Equipo unido y colaborativo</h3>
        </div>
      </div>
    </div>

    <div class="floating-n">
      <img
        :src="require('../../assets/newlanding/Landing/n-logo.png')"
        alt="Equipo unido y colaborativo"
        class="card-flot"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "CulturaComponent",
  data() {
    return {};
  },
};
</script>

<style scoped>
.cultura-container {
  position: relative;
  width: 100%;
  background-color: #f5f5f7;
  font-family: Arial, sans-serif;
  overflow: hidden;
}

.cultura-title {
  font-size: 1.8rem;
  color: #111111;
  padding: 1rem;
  text-align: left;
  font-family: "Poppins", sans-serif;
}

.cards-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
}

.cultura-card {
  flex: 1;
  min-width: 0;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.card-image-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 100%; /* 1:1 Aspect Ratio */
  overflow: hidden;
}

.card-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.card-title {
  position: absolute;
  bottom: 45%;
  top: 45%;
  left: 1rem;
  right: 1rem;
  width: 80%;
  color: white;
  font-size: 1.2rem;
  font-weight: bold;
  margin: auto;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
  text-align: center;
}

.floating-n {
  position: absolute;
  bottom: 0px;
  margin-bottom: -16px;
  margin-left: 240px;
}
.card-flot {
  width: 300px;
}

@media (max-width: 1024px) {
  .cultura-card {
    flex-basis: 48%;
  }
  .cultura-title {
    font-size: 1.2rem;
    padding: 20px 0px;
  }
  .floating-n {
    margin-bottom: -16px;
    margin-left: 240px;
  }
  .cards-container {
    /* padding: px; */
    width: 50%;
    margin: auto;
  }
}

@media (max-width: 768px) {
  .cultura-container {
    padding: 1.5rem;
  }

  /* .cultura-title {
    font-size: 1.6rem;
    margin-bottom: 1.5rem;
  } */

  .cards-container {
    flex-wrap: wrap;
  }
  .cultura-card {
    flex-basis: 100%;
    margin-bottom: 1rem;
  }

  .card-title {
    font-size: 1.2rem;
  }

  .floating-n {
    display: none; /* Ocultar la N flotante en móvil */
  }
  .cards-container {
    /* padding: px; */
    width: 70%;
  }
}
@media (max-width: 480px) {
  .cards-container {
    /* padding: px; */
    width: 90%;
  }
}
</style>
